import { useEffect } from 'react';
import useSupplierStore from '@/stores/supplier-session';
import { IApiSourcingContactEmail } from '@/services/swagger/easourcing/models';
import { usePushMessage, PushEventType } from '@/hooks/useWebSocket';

interface SupplierUpdatePayload {
  contactId: string;
  unreadCount: number;
  allUnreadCount: number;
}

export function useSupplierUpdate() {
  const { addNewContact, updateTotalUnreadCount, updateUnreadStatusMap, loadTotalUnreadCount } = useSupplierStore();

  // 菜单栏挂载时立即拉取总未读数，无需等待供应商列表展开
  useEffect(() => {
    loadTotalUnreadCount();
  }, [loadTotalUnreadCount]);

  usePushMessage<IApiSourcingContactEmail>(PushEventType.NEW_CONTACT, payload => {
    const content = payload?.content;
    if (content?.id) {
      addNewContact(content);
    }
  });

  usePushMessage<SupplierUpdatePayload>(PushEventType.CONTACT_UNREAD_COUNT, payload => {
    const content = payload?.content;
    if (content?.contactId) {
      const { contactId, unreadCount, allUnreadCount } = content;
      updateUnreadStatusMap(contactId, unreadCount);
      updateTotalUnreadCount(allUnreadCount);
    }
  });
}
